import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DataListModel, SmartTableConfigInterface} from '../../interface';
import {DeleteModalComponent} from '../../modal';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatDialog} from '@angular/material/dialog';


@Component({
  selector: 'app-smart-table',
  templateUrl: './smart-table.component.html',
  styleUrls: ['./smart-table.component.scss']
})
export class SmartTableComponent implements OnInit, OnChanges {

  @ViewChild(MatSort) sort: MatSort;
  @Input() config: SmartTableConfigInterface;
  @Input() data: DataListModel;
  @Output() itemOrNewClicked = new EventEmitter();
  @Output() deleteClicked = new EventEmitter();
  dataSource = new MatTableDataSource([]);

  constructor(public dialog: MatDialog) {
  }

  ngOnInit() {
    this.config.displayedColumns.push('deleteColumn');
  }

  addOrEditClicked(value?: object) {
    this.itemOrNewClicked.emit(value);
  }

  showDeleteModal(event, item) {
    event.stopPropagation();

    const dialogRef = this.dialog.open(DeleteModalComponent, {
      hasBackdrop: true,
      data: item,
    });



    dialogRef.componentInstance.onDelete.subscribe((data: any) => {
      this.deleteClicked.emit({item: data, dialogRef: dialogRef});
    });

  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.data.currentValue && changes.data.currentValue.items) {
      this.dataSource = new MatTableDataSource(changes.data.currentValue.items);
    } else {
      this.dataSource = new MatTableDataSource([]);
    }

    // this.dataSource.sort = this.sort;
  }

}
